import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "p-the-header-navi-profile-panel__icon" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  class: "p-the-header-navi-profile-panel__name",
  "data-translate-skip": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconUserImage = _resolveComponent("IconUserImage")!
  const _component_IconLogout = _resolveComponent("IconLogout")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", {
    class: "p-the-header-navi-profile-panel",
    style: _normalizeStyle({ backgroundColor: _ctx.colorCode })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_IconUserImage, {
        size: 24,
        "is-loading": _ctx.isLoading
      }, {
        default: _withCtx(() => [
          (_ctx.userAvatar)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.userAvatar,
                alt: `${_ctx.userName}`
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-loading"])
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.userName), 1),
    _createElementVNode("button", {
      class: "p-the-header-navi-profile-panel__logout",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
    }, [
      _createVNode(_component_IconBase, {
        width: 24,
        height: 24,
        "view-box": "0 0 24 24",
        "icon-color": "transparent"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IconLogout, { "icon-color": "#ffffff" })
        ]),
        _: 1
      })
    ])
  ], 4))
}